module.exports = __webpack_public_path__ + "img/1585582469.6695bc97.jpg";